import React from 'react';
import { TableCell } from '@mui/material';
import _ from 'lodash';
import { getNumberComma } from '../../utils/numberUtils';
import { billsSubHeaders } from '../../utils/balance-accounts';

// keyName => pp : 매입계산서 실적
const BillsAccountsCell = ({ data }) => {
  if (!data) {
    return null;
  }

  return billsSubHeaders.map((type, tIndex) => {
    let key = `${type.id}_${tIndex}`;

    let value = _.has(data, `${type.id}`) ? data[type.id] : '-';

    let formatValue = type.id !== 'profit' ? getNumberComma(value) : value;
    //let widthValue = (type.id !== 'profit') ? '80px' : '80px';

    return (
      <TableCell
        sx={{ width: '120px', paddingLeft: 0 }}
        align="right"
        key={key}
      >
        {formatValue}
      </TableCell>
    );
  });
};

export default BillsAccountsCell;
